import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import MaterialTooltip from "@mui/material/Tooltip";

import { StyledChildrenContainer } from "./styles";

const UnstyledHoverToOpen = ({
    className,
    children,
    open,
    ...tooltipProps
}) => {
    // passing open prop to MUI tooltip as null or undefined will disable hover behavior
    // only add the prop if it is truthy
    if (open) {
        tooltipProps.open = open;
    }
    return (
        <MaterialTooltip className={className} {...tooltipProps}>
            <StyledChildrenContainer
                className={className}
                tabIndex={tooltipProps.tabIndex || 0}
            >
                {children}
            </StyledChildrenContainer>
        </MaterialTooltip>
    );
};

const HoverToOpen = styled(UnstyledHoverToOpen)``;

HoverToOpen.propTypes = {
    className: PropTypes.string,
    open: PropTypes.bool,
    children: PropTypes.any.isRequired
};

export default HoverToOpen;
